import React from "react";
import Topbar from "./Topbar";
// import MobileHeader from "./MobileHeader";

import App from "../App";
import Footer from "./Footer";
import Sidebar from "./siderbar";
import { Outlet } from "react-router-dom";
const LayoutPage = () => {
  
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 960px)');
    const handleResize = () => setIsMobile(mediaQuery.matches);

    handleResize(); // Initial check
    mediaQuery.addEventListener('change', handleResize);

    return () => {
      mediaQuery.removeEventListener('change', handleResize);
    };
  }, []);
  return (
    
    <div id="___gatsby">
    <div   style={{outline:'none'}}
     tabIndex="-1" 
     id="gatsby-focus-wrapper">
        <div>
      {!isMobile && <Topbar />}
      {isMobile && <Sidebar/>}
    </div>
      
      
    <Outlet /> 

          <Footer />
    </div>
    <div
      id="gatsby-announcer"
      style={{
        position: 'absolute',
        top: 0,
        width: '1px',
        height: '1px',
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: 0,
      }}
      aria-live="assertive"
      aria-atomic="true"
    ></div>
    </div>
  );
};

export default LayoutPage;
